import React from 'react';
import { Card } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertTriangle, CheckCircle, Clock, Bell } from 'lucide-react';

export default function SmartAlerts({ 
  pendingApprovals = 0,
  slaViolations = 0,
  achievements = []
}) {
  const alerts = [];
  
  // Pending approvals
  if (pendingApprovals > 0) {
    alerts.push({
      type: 'warning',
      icon: Bell,
      title: 'Onay Bekleyen İşlemler',
      message: `${pendingApprovals} işlem onayınızı bekliyor`,
      color: 'bg-orange-50 border-orange-200 text-orange-800'
    });
  }
  
  // SLA violations
  if (slaViolations > 0) {
    alerts.push({
      type: 'danger',
      icon: AlertTriangle,
      title: 'SLA Uyarısı',
      message: `${slaViolations} talep SLA süresini aştı`,
      color: 'bg-red-50 border-red-200 text-red-800'
    });
  }
  
  // Achievements
  if (achievements.length > 0) {
    alerts.push({
      type: 'success',
      icon: CheckCircle,
      title: 'Başarı',
      message: achievements[0],
      color: 'bg-green-50 border-green-200 text-green-800'
    });
  }
  
  if (alerts.length === 0) return null;
  
  return (
    <div className="space-y-3">
      {alerts.map((alert, i) => {
        const Icon = alert.icon;
        return (
          <Alert key={i} className={alert.color}>
            <Icon className="h-5 w-5" />
            <AlertDescription className="ml-2">
              <span className="font-semibold">{alert.title}:</span> {alert.message}
            </AlertDescription>
          </Alert>
        );
      })}
    </div>
  );
}
